import { isProductionDeployment } from "@/utils/auth/dev-access"

export const LOCAL_PIPELINE_TITLE = "Run on your Local Pipeline"

/**
 * What the field does, in one line.
 */
export const LOCAL_PIPELINE_SUMMARY =
  "Routes this launch to the Local Pipeline matching your COVAL_DEV_ID."

/**
 * Return the deployment this app talks to.
 *
 * A worker claims work by dev_id and then resolves organizations through its own
 * configuration, so it has to be running the same environment as the app that wrote
 * the run row. Only the release build is production; every other build talks to staging.
 */
export function getCurrentDeployment(): string {
  return isProductionDeployment() ? "production" : "staging"
}

/**
 * Deployment names that must never be used as a dev_id.
 *
 * `dev_id` names one engineer's worker lane. A deployment name instead reads as an
 * instruction to route to that fleet, which is not what the field does, and no worker
 * claims a lane by that name.
 */
const RESERVED_DEV_IDS = ["prod", "staging", "dev"]

/**
 * Return why a dev_id is unusable, or null when it is fine.
 *
 * @param devId The value typed into a dev_id field.
 */
export function getDevIdError(devId: string): string | null {
  const normalized = devId.trim().toLowerCase()
  if (!RESERVED_DEV_IDS.includes(normalized)) {
    return null
  }
  return `"${normalized}" names a deployment, not a worker lane. Use the COVAL_DEV_ID from your own .dev_id file.`
}
